import React from "react";
import { FaUsers, FaCalendarAlt, FaShieldAlt,FaDesktop  } from "react-icons/fa";
import { Link } from "react-router-dom";
import "./Services.css";


const AboutPage = () => {
  return (
    <>
      {/* ================= HERO SECTION ================= */}
      <section className="about-hero">
        <div className="about-overlay"></div>

        <div className="about-content">
          <h1>À Propos de CFJEXPERT</h1>
          <p>
            Votre partenaire stratégique en gestion administrative
            <br />
            et accompagnement professionnel.
          </p>
        </div>

        {/* Wave bottom */}
        <div className="wave">
          <svg viewBox="0 0 1440 200" preserveAspectRatio="none">
            <path
              d="M0,160 C360,80 1080,240 1440,120 L1440,200 L0,200 Z"
              fill="#ffffff"
            />
          </svg>
        </div>
      </section>

      {/* ================= WHO WE ARE SECTION ================= */}
      <section className="who-section">
        <div className="top-curve"></div>

        <div className="who-container">
          {/* Left Content */}
          <div className="who-text">
            <h2>Qui Sommes-Nous ?</h2>
            <p>
              CFJEXPERT est un cabinet de conseil de premier plan, spécialisé dans la gestion administrative des entreprises, l’accompagnement stratégique 
              et l’optimisation des processus internes afin d’assurer une efficacité maximale.
            </p>
            <p>
              Nous offrons à nos clients des solutions complètes et intégrées, leur permettant de se concentrer pleinement sur le développement et la croissance de leur activité, tandis que nous prenons en 
              charge les aspects essentiels et administratifs avec professionnalisme et rigueur.
            </p>
          </div>

          {/* Right Image */}
          <div className="who-image">
            <img src="/image/office team.jpg" alt="Equipe CFJEXPERT" />
          </div>
        </div>
      </section>

      {/* ================= MISSION & VISION SECTION ================= */}
      <section className="mv-section">
        <div className="mv-container">
          <div className="mv-card">
            <h3>Notre Mission</h3>
            <p>
              Simplifier la gestion administrative des <strong>entreprises</strong> grâce à des solutions efficaces et personnalisées.
            </p>
          </div>

          <div className="mv-card vision">
            <h3>Notre Vision</h3>
            <p>
              Devenir un acteur de <strong>référence</strong> reconnu pour son <strong>professionnalisme</strong>, sa fiabilité et son <strong>innovation</strong>.
            </p>
          </div>
        </div>

        {/* Wave background bottom */}
        <div className="mv-wave">
          <svg viewBox="0 0 1440 160" preserveAspectRatio="none">
            <path
              fill="#c9d6ff"
              d="M0,64L48,69.3C96,75,192,85,288,96C384,107,480,117,576,117.3C672,117,768,107,864,90.7C960,75,1056,53,1152,64C1248,75,1344,117,1392,138.7L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
            ></path>
          </svg>
        </div>
      </section>

      {/* ================= CRÉATION ENTREPRISE SECTION ================= */}
      <section className="creation-section">
        <div className="creation-container">
          {/* Left Icon */}
          <div className="creation-icon">
            <img src="/image/image.jpg" alt="Idée" />
          </div>

          {/* Right Content */}
          <div className="creation-text">
            <h2>Création Entreprise Au Maroc</h2>
            <p>
              Vous avez un projet et vous souhaitez le concrétiser par la création
              d’une société au Maroc ?
            </p>
            <p className="highlight">
              CFJEXPERT vous apporte la solution idéale. <br />
              CFJEXPERT se charge de toutes les formalités de constitution de votre société, vous permettant
              une optimisation de votre temps ainsi que le concours d’une équipe d’experts
              pour répondre à toutes vos doléances avec l’efficacité exigée.
            </p>
          </div>
        </div>
      </section>
          <section className="why-section">
      <div className="why-container">
        <h2>
          Pourquoi Choisir <span>Servitium</span> ?
        </h2>
        <div className="underline"></div>

        <div className="cards">
          {/* Card 1 */}
          <div className="card">
            <FaUsers className="icon" />
            <h3>25000+</h3>
            <p>CODE LINES THIS MONTH</p>
          </div>

          {/* Card 2 */}
          <div className="card">
            <FaCalendarAlt className="icon" />
            <h3>150+</h3>
            <p>LAUNCHED PROJECTS</p>
          </div>

          {/* Card 3 */}
          <div className="card">
            <FaShieldAlt className="icon" />
            <h3>9900+</h3>
            <p>COFFEE CUPS THIS YEAR</p>
          </div>
           <div className="card">
            <FaDesktop  className="icon" />
            <h3>180+</h3>
            <p>REVIEWS AND RATINGS</p>
          </div>
        </div>
      </div>
    </section>
<section className="collab-section">
  <div className="collab-wrapper">
    <h2 className="collab-title">Demandez Votre Consultation 100% Gratuit !</h2>
           <Link to="/contact#consultation">
      <button className="btn-devis">Demander une Consultation</button>
    </Link>
  </div>
</section>

    </>
  );
};

export default AboutPage;
